import { useEffect, useState } from "react";
import { api, mediaUrl } from "@/lib/api";

const SIZE = {
  small: { img: "h-20", title: "text-sm", pad: "p-2" },
  medium: { img: "h-32", title: "text-lg", pad: "p-3" },
  large: { img: "h-56", title: "text-2xl", pad: "p-4" },
};

export function AdSlot({ position, className = "", label = "Advertisement", vertical = false }) {
  const [ads, setAds] = useState([]);

  useEffect(() => {
    api.get(`/ads?position=${position}`).then(({ data }) => setAds(data)).catch(() => setAds([]));
  }, [position]);

  if (!ads.length) return null;

  return (
    <div className={className} data-testid={`ad-slot-${position}`}>
      <p className="text-[10px] font-tech uppercase tracking-widest text-muted-page mb-2 text-center">{label}</p>
      <div className={vertical ? "space-y-4" : "grid gap-4 sm:grid-cols-2 lg:grid-cols-3"}>
        {ads.map((ad) => {
          const s = SIZE[ad.size] || SIZE.medium;
          return (
            <a
              key={ad.id}
              href={ad.target_url || "#"}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`ad-${ad.id}`}
              onClick={() => { api.post(`/ads/${ad.id}/click`).catch(() => {}); }}
              className="surface border rounded-xl overflow-hidden block transition-all hover:shadow-lg hover:-translate-y-0.5"
            >
              {ad.image_url && <img src={mediaUrl(ad.image_url)} alt={ad.title} className={`w-full object-cover ${s.img}`} />}
              <div className={s.pad}>
                <p className={`font-display font-semibold leading-tight ${s.title}`}>{ad.title}</p>
                {ad.sponsor_name && <p className="text-xs text-muted-page">Sponsored by {ad.sponsor_name}</p>}
              </div>
            </a>
          );
        })}
      </div>
    </div>
  );
}
